/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Toast_Approve_PnkInputs */

const vi_pkl_toast_approve_pnk = /** @type {(inputs: Pkl_Toast_Approve_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã duyệt phiếu nhập`)
};

/**

* @param {Pkl_Toast_Approve_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_toast_approve_pnk = /** @type {((inputs?: Pkl_Toast_Approve_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Toast_Approve_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_toast_approve_pnk(inputs)
});